import * as React from "react";
export class League extends React.PureComponent {
    render() {
        const { name, sportName, clickHandler } = this.props.result;
        return (React.createElement("div", { className: "rj-bet-search rj-bet-search__league-event", "data-uat": "div-search-league-details", onClick: clickHandler },
            React.createElement("div", { className: "rj-bet-search__event-name", "data-uat": "div-search-league-name" }, name),
            React.createElement("div", { className: "rj-bet-search__sport-name", "data-uat": "div-search-sport-name" }, sportName)));
    }
}
//# sourceMappingURL=League.js.map